import { getState, getStatePure, modifyState, unsetState } from '~src/state';
import { onErrorShowMessage } from '~src/errors';

export const onEffectSlideInFromTop = (event) => {
  event.preventDefault();

  const activeObject = window.canvas.getActiveObject();

  if (!activeObject) {
    onErrorShowMessage("Seleziona l'oggetto che vuoi animare");
  }

  const objectsOriginalValues = [];
  const objectIds = [];
  if (activeObject.type === 'activeSelection') {
    // TODO: support groups
    // for (const obj of activeObject.getObjects()) {
    //   objectsOriginalOpacity.push(obj.get('top'));
    //   obj.set({ opacity: 0 });
    //   objectIds.push(obj.giotto.objRefId);
    // }
  } else {
    objectsOriginalValues.push(activeObject.get('top'));
    objectIds.push(activeObject.giotto.objRefId);
  }

  const pendingAnimation = {
    objects: objectIds,
    fromProps: {
      top: -activeObject.get('height'),
    },
    toProps: {
      top: objectsOriginalValues[0],
      duration: 1,
      ease: 'Power4.easeOut',
    },
    title: 'Entra da sopra',
  };

  modifyState('pendingAnimation', pendingAnimation);

  const pages = getStatePure('pages');
  const currentPageIndex = getState('currentPageIndex');
  if (!pages[currentPageIndex].animations) {
    pages[currentPageIndex].animations = [];
  }
  pages[currentPageIndex].animations.push(pendingAnimation);
  modifyState('pages', pages);
  unsetState('pendingAnimation');
  if (activeObject.type === 'activeSelection') {
    // let i = 0;
    // for (const obj of activeObject.getObjects()) {
    //   obj.set({ opacity: objectsOriginalOpacity[i++] });
    // }
  } else {
    activeObject.set({ top: objectsOriginalValues[0] });
  }

  activeObject.giotto.animationParent.set({
    opacity: 1,
  });
  window.canvas.remove(activeObject);
  window.canvas.renderAll();
};
